// extracted by mini-css-extract-plugin
module.exports = {"password":"Password_password__34PZg","error":"Password_error__3Sf3C"};